(function (app, ng) {

    //fileViewerCtrl.$inject = ["$mdDialog"];
    //function fileViewerCtrl($mdDialog) {
    //    var $ctrl = this;

    //    ng.extend($ctrl,
    //    {
    //        close: close
    //    });

    //    function close() { $mdDialog.cancel(); };
    //};

})(window.app, window.angular);